import { Stack } from "native-base";

export const TableRow = ({ children, ...props }) => (
  <Stack direction="row" flexShrink={0} flexGrow={1} {...props}>
    {children}
  </Stack>
);
